// Authentication service for login/signup

export const login = async (email, password) => {
  try {
    const baseURL = (process.env.REACT_APP_API_URL || "http://localhost:3001").replace(/\/$/, "");
    const response = await fetch(baseURL + "/api/auth/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    const text = await response.text();
    console.log("Login response:", response.status, text);

    if (!response.ok) {
      try {
        const error = JSON.parse(text);
        throw new Error(error.message || "Login failed");
      } catch (e) {
        throw new Error("Login failed");
      }
    }

    try {
      return JSON.parse(text);
    } catch {
      throw new Error("Invalid response from server");
    }
  } catch (error) {
    console.error("Login error:", error);
    throw error;
  }
};

export const signup = async (email, password) => {
  try {
    const baseURL = (process.env.REACT_APP_API_URL || "http://localhost:3001").replace(/\/$/, "");
    const response = await fetch(baseURL + "/api/auth/signup", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    const text = await response.text();
    console.log("Signup response:", response.status, text);

    if (!response.ok) {
      try {
        const error = JSON.parse(text);
        throw new Error(error.message || "Signup failed");
      } catch (e) {
        throw new Error("Signup failed");
      }
    }

    try {
      return JSON.parse(text);
    } catch {
      throw new Error("Invalid response from server");
    }
  } catch (error) {
    console.error("Signup error:", error);
    throw error;
  }
};

export const logout = () => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("user");
};

export const getAuthToken = () => {
  return localStorage.getItem("authToken");
};

export const isAuthenticated = () => {
  return !!localStorage.getItem("authToken");
};

export const getCurrentUser = () => {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
};

export const resetPassword = async (email, newPassword) => {
  try {
    const baseURL = (process.env.REACT_APP_API_URL || "http://localhost:3001").replace(/\/$/, "");
    const response = await fetch(baseURL + "/api/auth/reset-password", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, newPassword }),
    });

    const text = await response.text();
    console.log("Reset password response:", response.status, text);

    if (!response.ok) {
      try {
        const error = JSON.parse(text);
        throw new Error(error.message || "Password reset failed");
      } catch (e) {
        throw new Error("Password reset failed");
      }
    }

    try {
      return JSON.parse(text);
    } catch {
      throw new Error("Invalid response from server");
    }
  } catch (error) {
    console.error("Reset password error:", error);
    throw error;
  }
};
